import { Languages } from "lucide-react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../select";

import { availableLanguages } from "@/config/languages";
import { useLanguageSelector } from "@/lib/hooks/useLanguageSelector";

const LanguageMenu = () => {
  const { currentLanguage, changeLanguage } = useLanguageSelector();

  return (
    <Select value={currentLanguage.code} onValueChange={changeLanguage}>
      <SelectTrigger data-slot="language-menu-trigger" className="gap-2 border-0 px-2 shadow-none ">
        <Languages />
        <SelectValue placeholder="Language">{currentLanguage.label}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {availableLanguages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="inline-flex gap-2 items-center">
              <Languages />
              {lang.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageMenu;
